import App from "./components/App.svelte";
import * as Sentry from "@sentry/browser";
import './assets/fonts/fonts.css';
import './styles.css';
import './auth0.css';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENV,
  denyUrls: ['Bearer'], // Make sure Urls with Bearer are not sent to Sentry
});


// User which should see v2 login but came to old login.
// When user has V2 enabled, its only possible to see old login with fb_auth_v2_session_enabled = false unless ga
const loginVersionHandler = () => {
  // localStorage.setItem('fb_auth_use_old_auth', 'true');

  const v2SessionValue = localStorage.getItem('fb_auth_v2_session_enabled');

  const redirect = `${window.location.origin}/v2/welcome/login`;
  
  // User has to see v2 login, redirect.
  if (v2SessionValue === 'true') {
    window.location.href = redirect;
    return;
  }
 
}

loginVersionHandler();

const app = new App({
  target: document.body
});

export default app;
